import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_30: FaireProductEntity = {
  token: "starter_collection_30",
  type: "product",
  name: "Matcha Green Apron",
  brandName: "Hedley & Bennett",
  imageUrl: "",
  priceDollars: 95,
  msrpDollars: 190,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
